import { render, staticRenderFns } from "./GarageDoorSizeAndMotorization.vue?vue&type=template&id=6aa854ff&scoped=true"
import script from "./GarageDoorSizeAndMotorization.vue?vue&type=script&lang=ts"
export * from "./GarageDoorSizeAndMotorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa854ff",
  null
  
)

export default component.exports